import script from "./LoadingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingModal.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingModal.vue?vue&type=style&index=0&id=7871d578&lang=scss&scoped=true"

import exportComponent from "F:\\Repos\\Freelance\\site-plan-viewerBH\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7871d578"]])

export default __exports__